<template>
  <section class="section" id="sec">
        <div class="columns">
            <!-- card-1 -->
            <div class="column">
                <div class="box">
                    <span class="iconify" data-icon="jam:computer-alt" data-inline="false"></span>
                    <h1 class="title">Responsive Design</h1>
                    <span class="line"></span>
                    <p class="content">Lorem ipsum dolor sit amet, ed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                </div>
            </div>
            <!-- card-2 -->
            <div class="column">
                <div class="box">
                    <span class="iconify" data-icon="jam:leaf" data-inline="false"></span>
                    <h1 class="title">Creative Design</h1>
                    <span class="line"></span>
                    <p class="content">Lorem ipsum dolor sit amet, ed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                </div>
            </div>
            <!-- card-3 -->
            <div class="column">
                <div class="box">
                    <span class="iconify" data-icon="jam:mug" data-inline="false"></span>
                    <h1 class="title">Mailchimp Ready</h1>
                    <span class="line"></span>
                    <p class="content">Lorem ipsum dolor sit amet, ed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: "cards",
  
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
